export const periodOptions = [
  {
    label: "5 sec",
    value: "5 sec"
  },
  {
    label: "15 sec",
    value: "15 sec"
  },
  {
    label: "30 sec",
    value: "30 sec"
  },
  {
    label: "1 min",
    value: "1 min"
  },
  {
    label: "3 min",
    value: "3 min"
  },
  {
    label: "5 min",
    value: "5 min"
  },
  {
    label: "10 min",
    value: "10 min"
  },
  {
    label: "30 min",
    value: "30 min"
  }
];

export const apdexOptions = [
  {
    label: "0.125 sec",
    value: "0.125 sec"
  },
  {
    label: "0.25 sec",
    value: "0.25 sec"
  },
  {
    label: "0.5 sec",
    value: "0.5 sec"
  },
  {
    label: "1 sec",
    value: "1 sec"
  },
  {
    label: "2 sec",
    value: "2 sec"
  }
];

export const protocolOptions = [
  {
    label: "HTTP(S)",
    value: "HTTP(S)"
  },
  {
    label: "ICMP",
    value: "ICMP"
  },
  {
    label: "TCP",
    value: "TCP"
  },
  {
    label: "DNS",
    value: "DNS"
  }
];

export const httpMethodOptions = [
  {
    label: "GET",
    value: "GET"
  },
  {
    label: "POST",
    value: "POST"
  },
  {
    label: "PUT",
    value: "PUT"
  },
  {
    label: "DELETE",
    value: "DELETE"
  },
  {
    label: "HEAD",
    value: "HEAD"
  }
];

export const dnsQueryTypeOptions = [
  {
    label: "A",
    value: "A"
  },
  {
    label: "AAAA",
    value: "AAAA"
  },
  {
    label: "TXT",
    value: "TXT"
  },
  {
    label: "CNAME",
    value: "CNAME"
  },
  {
    label: "MX",
    value: "MX"
  },
  {
    label: "NS",
    value: "NS"
  },
  {
    label: "ANAME",
    value: "ANAME"
  },
  {
    label: "SRV",
    value: "SRV"
  },
  {
    label: "PTR",
    value: "PTR"
  },
  {
    label: "ANY",
    value: "ANY"
  },
  {
    label: "CERT",
    value: "CERT"
  },
  {
    label: "DNSKEY",
    value: "DNSKEY"
  }
];
